export default __webpack_public_path__ + "static/media/advisory-board-img1.420e0c92.jpg";